var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }